(function() {
  angular.module('registration')
  .factory('DsoProfile', ['$resource', 'dsoRegistrationService', function($resource, dsoRegistrationService) {
    return $resource('/dsos', {},{
      save: {method: 'POST'
      , transformResponse: function(data, headers) {
        dsoRegistrationService.requestToken = headers()['x-dso-reg-req-token'];
        return angular.fromJson(data);
      }
    },
      validate: {method: 'POST', url: '/dsos/validateTaxIds'}
    });
  }])
  .factory('DsoEmail', ['$resource', 'dsoRegistrationService',
    function($resource, dsoRegistrationService) {
      return $resource('/dnDsos/:dsoId', {dsoId: '@id'}, {
        updateEmail: {method: 'POST',
          headers: {'x-dso-reg-req-token': dsoRegistrationService.requestToken},
          transformResponse: function(data, headers) {
            dsoRegistrationService.requestToken = headers()['x-dso-reg-req-token'];
          }
        }
      });
    }]);
})();
